module.exports = __webpack_public_path__ + "static/media/03.Falicitaion in FRANCE TOUR-2012 070.9b3c8ac9.jpg";